import { styled } from "@/stitches/config"

export const SBaseIllustration = styled("span", {
  svg: {
    display: "block",
    width: "100%",
    height: "100%",
  },
})
